import { render, staticRenderFns } from "./DuplicateMediaCallFromProjectBtn.vue?vue&type=template&id=ca69c60c&"
import script from "./DuplicateMediaCallFromProjectBtn.vue?vue&type=script&lang=js&"
export * from "./DuplicateMediaCallFromProjectBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca69c60c')) {
      api.createRecord('ca69c60c', component.options)
    } else {
      api.reload('ca69c60c', component.options)
    }
    module.hot.accept("./DuplicateMediaCallFromProjectBtn.vue?vue&type=template&id=ca69c60c&", function () {
      api.rerender('ca69c60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/DuplicateMediaCallFromProjectBtn.vue"
export default component.exports